// Constants
const TIME_CONSTANTS = {
    SECOND: 1000,
    MINUTE: 60 * 1000,
    HOUR: 60 * 60 * 1000,
    COUNTDOWN_INTERVAL: 15 * 60 * 1000 // 15 minutes
};

// Utility functions
const utils = {
    padTime: (num) => String(num).padStart(2, "0"),
    
    updateElements: (selector, content) => {
        document.querySelectorAll(selector).forEach(el => el.innerText = content);
    },
    
    scrollToElement: (selector) => {
        const element = document.querySelector(selector);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
    },
    
    isProductPage: () => document.body.className.includes('product')
};

// Countdown functionality
function initCountdown() {
    let nextVisitTime = Date.now() + TIME_CONSTANTS.COUNTDOWN_INTERVAL;
    
    const updateCountdown = () => {
        const now = Date.now();
        let distance = nextVisitTime - now;

        if (distance <= 0) {
            nextVisitTime = Date.now() + TIME_CONSTANTS.COUNTDOWN_INTERVAL;
            distance = nextVisitTime - now;
        }

        const hours = utils.padTime(Math.floor(distance / TIME_CONSTANTS.HOUR));
        const minutes = utils.padTime(Math.floor((distance % TIME_CONSTANTS.HOUR) / TIME_CONSTANTS.MINUTE));
        const seconds = utils.padTime(Math.floor((distance % TIME_CONSTANTS.MINUTE) / TIME_CONSTANTS.SECOND));

        utils.updateElements(".hours", hours);
        utils.updateElements(".minutes", minutes);
        utils.updateElements(".seconds", seconds);
    };

    setInterval(updateCountdown, TIME_CONSTANTS.SECOND);
}

// Promo date functionality
function updatePromoDate() {
    const options = { month: 'short', day: 'numeric', timeZone: 'America/Los_Angeles' };
    const today = new Date().toLocaleDateString('en-US', options).toUpperCase();
    
    utils.updateElements('.promo-date-end', ' ' + today);
}

// Scroll button functionality
function initScrollButtons() {
    document.querySelectorAll('.scroll-btn').forEach(button => {
        button.addEventListener('click', () => {
            utils.scrollToElement('.product__details--product-page');
        });
    });
}

// Fixed ATC functionality using IntersectionObserver
function initFixedATC() {
    if (!utils.isProductPage()) return;
    
    const atcBtn = $('.product-block--form .purchase-details__buttons .global-button--primary');
    const productForm = $('.product-block--form .purchase-details__buttons');

    if (productForm.length === 0 || atcBtn.length === 0) {
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                atcBtn.addClass('fixed_atc');
                $('body').addClass('fixed_atc_body');
            } else {
                atcBtn.removeClass('fixed_atc');
                $('body').removeClass('fixed_atc_body');
            }
        });
    });

    observer.observe(productForm[0]);
}

// Accordion functionality (jQuery)
(function($) {
    function initAccordion() {
        $('.accordion-header').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const $header = $(this);
            const $content = $header.next('.accordion-content');
            
            // Close other accordions and remove active class
            $('.accordion-content').not($content).slideUp();
            $('.accordion-header').not($header).removeClass('active');
            
            // Toggle current accordion
            $content.slideToggle();
            $header.toggleClass('active');
        });
    }
    
    $(document).ready(initAccordion);
})(jQuery);

// Get Location
function getVisitorBrowsingContext() {
    const browsingContext = localStorage.getItem('browsing_context');
    
    if (browsingContext) {
      return Promise.resolve(JSON.parse(browsingContext));
    } else {
      return fetch('/browsing_context_suggestions.json')
        .then(res => res.json())
        .then(data => {
          localStorage.setItem('browsing_context', JSON.stringify(data));
          return data;
        })
        .catch(error => {
          console.error('Error fetching browsing context data:', error);
        });
    }
  }

// Main initialization - Single DOMContentLoaded listener
document.addEventListener("DOMContentLoaded", function() {
    initCountdown();
    initScrollButtons();
    initFixedATC();
    updatePromoDate();

    getVisitorBrowsingContext()
    .then(data => {
      if (data) {
        let freeShippingThreshold = 40; 
        let isUS = data.detected_values.country.handle === 'US';
        
        if (!isUS) {
          freeShippingThreshold = 80; 
        }
  
        const freeShippingText = document.querySelectorAll('.free-shipping-text');
        const freeShippingBanner = document.querySelector('.free-shipping-banner');
        
        for (let i = 0; i < freeShippingText.length; i++) {
          freeShippingText[i].textContent = "Free Shipping Over $" + freeShippingThreshold;
        }
        
        freeShippingBanner.textContent = "Free Shipping For Orders Over $" + freeShippingThreshold + ' - Today Only!';
        
      } else {
        console.log("Could not retrieve IP and country information.");
      }
    })
    .catch(error => {
      console.error('Failed to get browsing context:', error);
    });
});